import { render, staticRenderFns } from "./noReview.vue?vue&type=template&id=555fe949&scoped=true"
import script from "./noReview.vue?vue&type=script&lang=js"
export * from "./noReview.vue?vue&type=script&lang=js"
import style0 from "./noReview.vue?vue&type=style&index=0&id=555fe949&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555fe949",
  null
  
)

export default component.exports